import React from 'react';
import { Button, Icon, Text } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import { useFormState } from 'react-hook-form';
import useToggleCompanyOverview from '../../hooks/useToggleCompanyOverview';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import usePreviousQuestion from '../../../../../hooks/progression/usePreviousQuestion';

interface Props {
  iconSize?: string;
}

const BottomBarPreviousButton: React.FC<React.PropsWithChildren<Props>> = ({
  iconSize,
}) => {
  const { t } = useTranslation();
  const { isOverview } = useToggleCompanyOverview();
  const { isSubmitting } = useFormState();
  const { previousQuestion } = usePreviousQuestion();
  const { position } = useFlowsRouteParams();
  const isViewOnlyMode = useFlowsSelector(
    (state) => state.flows.isViewOnlyModeOn,
  );
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );

  const onPrevClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    previousQuestion();
  };

  const isFirst = position ? parseInt(position) === 0 : lastPosition === 0;

  return (
    <Button
      visibility={isFirst && isViewOnlyMode ? 'hidden' : 'visible'}
      data-test-id="COMPANY-SCAN_BOTTOM-BAR_ACTION-BUTTON_PREVIOUS"
      minW={{ base: '12', tablet: '40' }}
      onClick={onPrevClick}
      variant="secondary"
      borderRadius="full"
      w="fit-content"
      leftIcon={<Icon name="GeneralActionsArrowLeft" boxSize={iconSize} />}
      pr={{ base: '4', laptopL: '8' }}
      disabled={isSubmitting || isOverview}
    >
      <Text display={{ base: 'none', tabletS: 'block' }}>{t('PREVIOUS')}</Text>
    </Button>
  );
};

export default BottomBarPreviousButton;
